<template>
  <div class="theme-heading">
    <div class="theme-heading__avatar">
      <img src="/static/img/avatar/study.png" loading="lazy" alt="зоозавр"/>
    </div>
    <div class="theme-heading__bullet">Тема 1</div>
    <h1 class="theme-heading__title">Появление питомца в доме</h1>
    <p class="theme-heading__text">Что важно знать?</p>
  </div>

  <div class="topic">
    <div class="theme-point"><span class="theme-point__number">1</span>
      <h2 class="theme-point__title">Проверенный заводчик</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-1/cat-1-1.webp" type="image/webp">
          <img src="/static/img/theme-1/cat-1-1.png" alt="Проверенный заводчик"/>
        </picture>
      </div>
      <p class="theme-point__text">Очень важно выбрать проверенного заводчика, ведь от&nbsp;этого часто зависят здоровье и&nbsp;внешность котенка.<br><br>Перед контактом с&nbsp;заводчиком постарайтесь найти данные о&nbsp;нём в&nbsp;сети: информацию о&nbsp;питомнике и&nbsp;отзывы от&nbsp;текущих владельцев. Во&nbsp;время общения узнайте у&nbsp;заводчика подробности о&nbsp;будущем питомце: дату рождения, какое питание получает котенок и&nbsp;в&nbsp;каких условиях содержится, есть&nbsp;ли документы.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Найти проверенных и&nbsp;добросовестных заводчиков можно на&nbsp;<span class="accent">профессиональной платформе Kinpet</span>. Там представлены заводчики со&nbsp;знаком PRO, что гарантирует безопасность сделки и&nbsp;наличие проверенных документов</p>
      </div>
      <div class="theme-point__button">
      <a
        class="btn"
        href="https://kinpet.ru/rossiya/koshki/?sellerType=pro&utm_source=royalcanin&utm_medium=banner&utm_campaign=school_pp"
        target="_blank"
        onclick="sendEventYM(
           102182679,
           'find_pet_click_btn',
         );"
      >
        Найти питомца
      </a>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">2</span>
      <h2 class="theme-point__title">Важность сна</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-1/cat-1.webp" type="image/webp">
          <img src="/static/img/theme-1/cat-1.png" alt="Важность сна"/>
        </picture>
      </div>
      <p class="theme-point__text">Для поддержания здоровья и&nbsp;хорошего самочувствия котятам нужно много спать. Котята могут спать <span class="accent">до&nbsp;20&nbsp;часов в&nbsp;сутки</span>, а&nbsp;взрослые кошки&nbsp;&mdash; <span class="accent">до&nbsp;18&nbsp;часов</span>.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Место для сна кошки должно располагаться на&nbsp;достаточном удалении от&nbsp;других важных зон (мисок для корма и&nbsp;воды, туалетного лотка и&nbsp;т.&nbsp;д.) и, в&nbsp;идеале, не&nbsp;в&nbsp;спальне хозяина.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">3</span>
      <h2 class="theme-point__title">Кошки существуют <br> в&nbsp;трехмерном пространстве</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-1/cat-2.webp" type="image/webp">
          <img src="/static/img/theme-1/cat-2.png" alt="Кошки существуют &lt;br&gt; в&amp;nbsp;трехмерном пространстве"/>
        </picture>
      </div>
      <p class="theme-point__text">Необходимо позаботиться о&nbsp;месте для отдыха и&nbsp;игр не&nbsp;только на&nbsp;уровне пола, но&nbsp;и&nbsp;<span class="accent">на&nbsp;некоторой высоте</span>.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Укрытие на&nbsp;высоте, куда кошка может забираться при необходимости, поможет реализовать ее&nbsp;природные инстинкты: лазить, наблюдать за&nbsp;происходящим вокруг, прыгать, атаковать «добычу».</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">4</span>
      <h2 class="theme-point__title">Игровая зона</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-1/cat-3.webp" type="image/webp">
          <img src="/static/img/theme-1/cat-3.png" alt="Игровая зона"/>
        </picture>
      </div>
      <p class="theme-point__text">Чтобы кошка могла точить когти, не&nbsp;нанося вреда мебели и&nbsp;занавескам, можно установить <span class="accent">когтеточку, игровой комплекс для&nbsp;кошек или сизалевый коврик</span>.</p>

      <div class="theme-point__block display--mobile">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Чтобы побудить кошку точить когти в&nbsp;&laquo;специально отведенных местах&raquo;, <span class="accent">можно распылить в&nbsp;этой зоне спрей с&nbsp;запахом кошачьей мяты</span>.</p>
      </div>

      <p class="theme-point__text">В&nbsp;предоставленных владениях котенок будет развлекаться долгими часами, а&nbsp;значит, игровая зона должна быть самой большой&nbsp;по&nbsp;размерам. Питомец сможет здесь вдоволь бегать и&nbsp;забираться на&nbsp;высоту, используя для этого столы,</p>

      <p class="theme-point__text">Зона кормления не&nbsp;должна располагаться рядом с&nbsp;туалетным лотком.</p>

      <div class="theme-point__block display--mobile">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text"><span class="accent">Корзинка котенка должна располагаться в&nbsp;теплом месте</span> (батарея, место у&nbsp;камина, у&nbsp;окна на&nbsp;солнечную сторону), но&nbsp;недалеко от&nbsp;расположения хозяина, т.к кошки хотят быть всегда рядом.</p>
      </div>

      <div class="theme-point__block-group">
        <div class="theme-point__block display--desktop">
          <div class="theme-point__block-icon">
            <svg class="icon-paw">
              <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
            </svg>
          </div>
          <div class="theme-point__block-text">Чтобы побудить кошку точить когти в&nbsp;&laquo;специально отведенных местах&raquo;, <span class="accent">можно распылить в&nbsp;этой зоне спрей с&nbsp;запахом кошачьей мяты</span>.</div>
        </div>
        <div class="theme-point__block display--desktop">
          <div class="theme-point__block-icon">
            <svg class="icon-paw">
              <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
            </svg>
          </div>
          <div class="theme-point__block-text"><span class="accent">Корзинка котенка должна располагаться в&nbsp;теплом месте</span> (батарея, место у&nbsp;камина, у&nbsp;окна на&nbsp;солнечную сторону), но&nbsp;недалеко от&nbsp;расположения хозяина, т.к кошки хотят быть всегда рядом.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="topic__img">
    <img src="/static/img/zoozavr.png" loading="lazy" alt="зоозавр"/>
  </div>

  <button
  class="btn topic__btn"
  @click="$emit('goToQuiz')"
  onclick="sendEventYM(
     102182679,
     'quiz1_click_btn',
   );"
  >
  Закрепить знания
  </button>
</template>

<script>
export default {
  name: 'LessonCatsTopic1FutureOwner',
}
</script>

<style scoped>
</style>
